import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { CartContext } from '../context/CartContext'; // Usamos tu CartContext existente
import styles from '../styles/Home.module.css'; // Asegúrate de que tienes el archivo de estilos
import cartIcon from '../assets/icons/cart-icon.webp'; // Ruta de tu ícono del carrito

const CartButton = () => {
    const { cartItems } = useContext(CartContext); // Obtener los items del carrito desde el contexto

    // Calcular el total de productos en el carrito
    const totalItems = cartItems.reduce((total, item) => total + item.quantity, 0);

    // Añadir clase de parpadeo si hay productos en el carrito
    const cartLinkClass = totalItems > 0 ? `${styles.cartLink} ${styles.blinking}` : styles.cartLink;

    return (
        <div className={styles.cartButtonContainer}>
            <Link to="/cart" className={cartLinkClass}>
                <img src={cartIcon} alt="Gangas guardadas" className={styles.cartIcon} />
                <span className={styles.cartCounter}>{totalItems}</span>
                Guardados
            </Link>
        </div>
    );
};

export default CartButton;
